import React, { useEffect, useState } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';
import { Paginator } from 'primereact/paginator';
import Loader from '../../components/loader';

function App() {

    const [loader, setLoader] = useState(false);
    const userID = sessionStorage.getItem("TRCUserId");
	const userEmail = sessionStorage.getItem("TRCUserEmail");
	const userName = sessionStorage.getItem("TRCUserName");
	const userPosition = sessionStorage.getItem("TRCUserPosition");
	const userType = sessionStorage.getItem("TRCUserType");

    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);  
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());  

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    
    const months = [
        { label: 'January', value: 1 },
        { label: 'February', value: 2 },
        { label: 'March', value: 3 },
        { label: 'April', value: 4 },
        { label: 'May', value: 5 },
        { label: 'June', value: 6 },
        { label: 'July', value: 7 },
        { label: 'August', value: 8 },
        { label: 'September', value: 9 },
        { label: 'October', value: 10 },
        { label: 'November', value: 11 },
        { label: 'December', value: 12 },
    ];

    const years = Array.from({ length: currentYear - 2024 }, (_, i) => {
        const year = 2025 + i;
        return { label: year.toString(), value: year };
    });

    const [orderData, setOrderData] = useState([]);
    const [routeData, setRouteData] = useState([]);
    // const [dealerData, setDealerData] = useState([]);

    useEffect(() => {
        const getdata = async () => {
            setLoader(true);

            const headers = {
                'Content-Type': 'application/json',
                'X-API-KEY': 'erpTrucoo'
            };

            try {
                const orderAPI = await axios.post('https://api.trucoo.in/invoice/monthly/', {month: selectedMonth, year: selectedYear}, {headers});
                // const dealerAPI = await axios.get('https://api.trucoo.in/dealers/view/', {headers});
                const routeAPI = await axios.post('https://api.trucoo.in/routes/view/', {},{headers});

                if (orderAPI.data.status === 'success') {
                    setOrderData(orderAPI.data.data || []);
                }else{
                    setOrderData([]);
                }
                // if (dealerAPI.data.status === 'success') {
                //     setDealerData(dealerAPI.data.data || []);
                // }
                if (routeAPI.data.status === 'success') {
                    setRouteData(routeAPI.data.routes || []);
                }else{
                    setRouteData([]);
                }
            } catch (error) {
                console.error("Error:", error.orderAPI || error.message);
                setOrderData([]);
            }
            setLoader(false);
        };
        getdata();
    }, [selectedMonth, selectedYear]);

    const downloadExcel = () => {
        const ws = XLSX.utils.table_to_sheet(document.getElementById('printableArea'));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Invoice Data');
        XLSX.writeFile(wb, `Incentive_${selectedMonth}_${selectedYear}.xlsx`);
    };

    const getLTROld = (dealer, type) => {
        const allOrders = orderData.filter(order => order?.dealerId === dealer);
            let totlLTR = 0;
            allOrders.forEach(order => {
                if (order?.orderData) {
                    order?.orderData?.forEach(item => {
                        if (item?.itemType === type) {
                            totlLTR += ((parseFloat(item?.qty) * parseFloat(item?.itemGrade)) / (parseFloat(item?.itemWeight)/1000));
                        }
                    });
                }
            });

            return totlLTR.toFixed(2);
    };

    const dealerProductMap = {};

    orderData.forEach(order => {
        const dealerId = order?.dealerId;
        if (!dealerProductMap[dealerId]) {
            dealerProductMap[dealerId] = {
            milk: 0,
            curd: 0,
            buttermilk: 0
            };
        }

        order?.orderData?.forEach(item => {
            const { itemType, qty, itemGrade, itemWeight } = item;
            const liters = (parseFloat(qty) * parseFloat(itemGrade)) / (parseFloat(itemWeight) / 1000);
            if (dealerProductMap[dealerId][itemType] !== undefined) {
                dealerProductMap[dealerId][itemType] += liters;
            }
        });
    });

    const getLTR = (dealerId, type, routeId) => {
        let total = 0;
        let incTotal = 0;
        orderData.forEach(order => {
            const discountData = JSON.parse(order.discountData || "[]");
            // console.log(discountData);
            if (order?.dealerId === dealerId && order?.dealerData?.route === routeId) {
                order?.orderData?.forEach(item => {
                    if (item?.itemType === type) {
                        const itemDisc = Array.isArray(discountData) ? discountData?.filter(dics => dics?.item === item?.itemId) : null;
                        const itemInc = parseFloat(item?.incValue || 0);
                        let packets = 0;

                        // console.log('itemInc', itemInc);

                        const qty = (parseFloat(item?.qty) * parseFloat(item?.itemGrade))
                        const weight = ( qty * (parseFloat(item?.itemWeight) / 1000));
                        if(itemDisc?.length > 0){
                            const type = itemDisc[0]?.type;
                            const discount = itemDisc[0]?.discount;
                            const value = itemDisc[0]?.value;

                            if(discount === 'amount'){

                                if(type === 'grade'){
                                    packets = ((value * parseFloat(item.qty)) / parseFloat(item.itemPrice));
                                }
                                
                                if(type === 'liters'){
                                    packets = (value * weight) / parseFloat(item.itemPrice);
                                }

                                if(type === 'packet'){
                                    packets = (value * qty) / parseFloat(item.itemPrice);
                                }
                            }

                            if(discount === 'packet'){

                                if(type === 'grade'){
                                    packets = (value * parseFloat(item.itemGrade));
                                }
                                
                                if(type === 'liters'){
                                    packets = (value * weight);
                                }

                                if(type === 'packet'){
                                    packets = (value * qty);
                                }
                            }

                            // console.log('--------------');
                            // console.log(qty);
                            // console.log(weight);
                            // console.log(discount);
                            // console.log(type);
                            // console.log(item.itemGrade);
                            // console.log(item.itemPrice);
                            // console.log(item.qty);
                            // console.log(value);
                            // console.log(packets);
                        }
                        
                        
                        const disWeight = packets * (parseFloat(item?.itemWeight) / 1000);
                        total += (weight - disWeight);
                        incTotal += (itemInc * total);
                    }
                });
            }
        });

        
        return {total, incTotal};
    };  


    // console.log('orderData', orderData);
    // console.log('dealerData', dealerData);
    // console.log('routeData', routeData);

    return (
        <>
            {loader && <Loader /> }
            <Header />
            <Sidebar />

            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="box">
                            <div className="box-header with-border">
                                
                                <div className="row">
                                    <div className="col-lg-6 mt-2">
                                        <h4 className="box-title">Incentive</h4>
                                        <p className="mb-0 box-subtitle">Incentive Report</p>
                                    </div>
                                    <div className="col-lg-2 mt-2">
                                        <select value={selectedMonth} onChange={(e) => setSelectedMonth(Number(e.target.value))} className="form-select">
                                            {months.map((month) => (
                                                <option key={month.value} value={month.value}>{month.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-lg-2 mt-2">
                                        <select value={selectedYear} onChange={(e) => setSelectedYear(Number(e.target.value))} className="form-select">
                                            {years.map((month) => (
                                                <option key={month.value} value={month.value}>{month.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-lg-2 mt-2" align="right">
                                        <button className="btn btn-success btn-sm" onClick={downloadExcel}><i className="fa fa-download"></i> Excel</button>
                                    </div>    
                                </div>    

                                <div className="col-lg-12 mt-4">
                                    <div className="table-responsive" style={{width: '100%', height: '65vh', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                                    <table style={{whiteSpace: 'nowrap'}} className="table-sm table-bordered nowrap fs-10" id="printableArea" width='100%'>
                                            <thead>
                                                <tr className="text-dark text-center" style={{ position: 'sticky', top: '-1px', zIndex: 2, backgroundColor: '#f8f9fa' }}>
                                                    <th>S.No</th>
                                                    <th>ROUTE</th>
                                                    <th>DEALER</th>
                                                    <th>MILK</th>
                                                    <th>CURD</th>
                                                    <th>BM</th>
                                                    <th>TOTAL LTR</th>
                                                    <th>NEW INC</th>
                                                    <th>INC</th>
                                                    <th>SEC-INC</th>
                                                    <th>MARGIN</th>
                                                    <th>TRANSPORT</th>
                                                    <th>C/F</th>
                                                    <th>LEAKAGE</th>
                                                    <th>TOTAL CLAIM</th>
                                                    <th>TOTAL AMOUNT</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {routeData?.map((route, routeIndex) => {
                                                    const groupedDealers = {};

                                                    orderData.forEach(order => {
                                                    if (order?.dealerData?.route === route.id) {
                                                        const dealerId = order.dealerData?.id;
                                                        if (!groupedDealers[dealerId]) {
                                                        groupedDealers[dealerId] = {
                                                            dealerData: order.dealerData
                                                        };
                                                        }
                                                    }
                                                    });

                                                    const dealers = Object.values(groupedDealers);

                                                    // Initialize route total accumulators
                                                    let routeMilk = 0, routeCurd = 0, routeBM = 0;
                                                    let routeTotalLTR = 0, routeTotalAmount = 0;
                                                    let routeIns = 0, routeSecIns = 0, routeMargin = 0, routeTrans = 0, routeLeakage = 0, routeCNF = 0, routeNetClaim = 0, newInc = 0;

                                                    return dealers.length > 0 ? (
                                                    <>
                                                        {dealers.map((dealer, dealerIndex) => {
                                                        const { dealerData } = dealer;
                                                        const dealerId = dealerData?.id;

                                                        const { total: milkLTR, incTotal: milkIncTotal } = getLTR(dealerId, 'milk', route.id);
                                                        const { total: curdLTR, incTotal: curdIncTotal } = getLTR(dealerId, 'curd', route.id);
                                                        const { total: bmLTR, incTotal: bmIncTotal } = getLTR(dealerId, 'buttermilk', route.id);
                                                        const totalLTR = milkLTR + curdLTR + bmLTR;

                                                        const leakageValue = parseFloat(dealerData?.leakage || 0);
                                                        const insValue = parseFloat(dealerData?.incentive || 0);
                                                        const marginValue = parseFloat(dealerData?.margin || 0);
                                                        const cNfValue = parseFloat(dealerData?.cnf || 0);
                                                        const transValue = parseFloat(dealerData?.transPort || 0);
                                                        const secInsValue = parseFloat(dealerData?.secIns || 0);

                                                        const totalClaim = insValue + secInsValue + marginValue + transValue + cNfValue + leakageValue;
                                                        const totalAmount = totalLTR * totalClaim;

                                                        const totalInc = milkIncTotal + curdIncTotal + bmIncTotal;

                                                        // Accumulate route totals
                                                        routeMilk += milkLTR;
                                                        routeCurd += curdLTR;
                                                        routeBM += bmLTR;
                                                        routeTotalLTR += totalLTR;
                                                        routeTotalAmount += totalAmount;
                                                        routeIns += insValue;
                                                        routeSecIns += secInsValue;
                                                        routeMargin += marginValue;
                                                        routeTrans += transValue;
                                                        routeLeakage += leakageValue;
                                                        routeCNF += cNfValue;
                                                        routeNetClaim += totalClaim;
                                                        newInc += totalInc;
                                                        return (
                                                            <tr key={`${routeIndex}-${dealerIndex}`}>
                                                            {dealerIndex === 0 && (
                                                                <>
                                                                <td rowSpan={dealers.length + 1}>{routeIndex + 1}</td>
                                                                <td rowSpan={dealers.length + 1}>{route.route}</td>
                                                                </>
                                                            )}
                                                            <td>{dealerData?.dealer}</td>
                                                            <td className="text-end">{milkLTR.toFixed(2)}</td>
                                                            <td className="text-end">{curdLTR.toFixed(2)}</td>
                                                            <td className="text-end">{bmLTR.toFixed(2)}</td>
                                                            <td className="text-end">{totalLTR.toFixed(2)}</td>
                                                            <td className="text-end">{totalInc.toFixed(2)}</td>
                                                            <td className="text-end">{insValue.toFixed(2)}</td>
                                                            <td className="text-end">{secInsValue.toFixed(2)}</td>
                                                            <td className="text-end">{marginValue.toFixed(2)}</td>
                                                            <td className="text-end">{transValue.toFixed(2)}</td>
                                                            <td className="text-end">{cNfValue.toFixed(2)}</td>
                                                            <td className="text-end">{leakageValue.toFixed(2)}</td>
                                                            <td className="text-end">{totalClaim.toFixed(2)}</td>
                                                            <td className="text-end">{totalAmount.toFixed(2)}</td>
                                                            </tr>
                                                        );
                                                        })}

                                                        {/* Route total row */}
                                                        <tr>
                                                        <th className="bg-light">Route Total</th>
                                                        <th className="text-end bg-light">{routeMilk.toFixed(2)}</th>
                                                        <th className="text-end bg-light">{routeCurd.toFixed(2)}</th>
                                                        <th className="text-end bg-light">{routeBM.toFixed(2)}</th>
                                                        <th className="text-end bg-light">{routeTotalLTR.toFixed(2)}</th>
                                                        <th className="text-end bg-light">{newInc.toFixed(2)}</th>
                                                        <th className="text-end bg-light">{routeIns.toFixed(2)}</th>
                                                        <th className="text-end bg-light">{routeSecIns.toFixed(2)}</th>
                                                        <th className="text-end bg-light">{routeMargin.toFixed(2)}</th>
                                                        <th className="text-end bg-light">{routeTrans.toFixed(2)}</th>
                                                        <th className="text-end bg-light">{routeCNF.toFixed(2)}</th>
                                                        <th className="text-end bg-light">{routeLeakage.toFixed(2)}</th>
                                                        <th className="text-end bg-light">{routeNetClaim.toFixed(2)}</th>
                                                        <th className="text-end bg-light">{routeTotalAmount.toFixed(2)}</th>
                                                        </tr>
                                                    </>
                                                    ) : (
                                                    <tr key={routeIndex}>
                                                        <td>{routeIndex + 1}</td>
                                                        <td>{route.route}</td>
                                                        <td colSpan="13" className="text-left text-danger">No Orders for this Route</td>
                                                    </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );

} export default App;